export default __webpack_public_path__ + "static/media/red-arrow-right.cea38c18.svg";